<hw-page-header header="term.di-04.header" class="page-header">
  <div class="content float-right">
    <button
      class="button"
      type="button"
      nz-button
      nzType="primary"
      *ngIf="version?.status !== 'final' || isNullOrInFuture(version.valid.upper)"
      (click)="update()">
      {{ 'core.btn.save' | translate }}
    </button>
  </div>
</hw-page-header>

<nz-content class="main">
  <ng-container *ngIf="dictionary">
    <hw-form-row>
      <hw-form-item *hwFormCol label="term.di-04.id">
        {{ dictionary.id }}
      </hw-form-item>
    </hw-form-row>
    <hw-form-row>
      <hw-form-item *hwFormCol label="term.di-04.title">
        {{ dictionary.title | localName }}
      </hw-form-item>
    </hw-form-row>
    <hw-form-row>
      <hw-form-item *hwFormCol label="term.di-04.name">
        {{ dictionary.names | localName }}
      </hw-form-item>
    </hw-form-row>
  </ng-container>
  <ng-container *ngIf="version">
    <nz-divider nzText="{{ 'term.di-04.version' | translate }}" nzOrientation="left"></nz-divider>
    <hw-form-row>
      <hw-form-item *hwFormCol label="term.di-04.version-number">
        {{ version.version }}
      </hw-form-item>
    </hw-form-row>
    <hw-form-row>
      <hw-form-item *hwFormCol label="term.di-04.status">
        {{ version.status }}
      </hw-form-item>
    </hw-form-row>
    <hw-form-row>
      <hw-form-item *hwFormCol label="term.di-04.valid-from">
        <hw-date-picker *ngIf="version.status !== 'final'" [(ngModel)]="version.valid.lower"></hw-date-picker>
        <span *ngIf="version.status === 'final'">{{ version.valid.lower | localDate }}</span>
      </hw-form-item>
    </hw-form-row>
    <hw-form-row>
      <hw-form-item *hwFormCol label="term.di-04.valid-to">
        <hw-date-picker
          *ngIf="version.status !== 'final' || isNullOrInFuture(version.valid.upper)"
          [(ngModel)]="version.valid.upper"></hw-date-picker>
      </hw-form-item>
    </hw-form-row>
    <hw-form-row>
      <hw-form-item *hwFormCol label="term.di-04.description">
        <textarea
          nz-input
          name="description"
          *ngIf="version.status !== 'final'"
          [(ngModel)]="version.description"></textarea>
        <span *ngIf="version.status === 'final'">{{ version.description }}</span>
      </hw-form-item>
    </hw-form-row>
  </ng-container>

  <hw-table header="term.di-04.concepts.title" *ngIf="version && dictionary">
    <div headerContent>
      <button
        class="button"
        [routerLink]="['/dictionaries', dictionary.id, 'versions', version.version, 'concepts', 'add']"
        nz-button
        nzType="secondary">
        {{ 'term.di-04.button.add-concept' | translate }}
      </button>
    </div>
    <nz-table #nzTable [nzData]="version.concepts" nzSize="small" nzHideOnSinglePage="true" nzShowSizeChanger="false">
      <thead>
        <tr>
          <th>{{ 'term.di-04.concepts.code' | translate }}</th>
          <th>{{ 'term.di-04.concepts.names' | translate }}</th>
          <th *ngFor="let attr of dictionary.attributes | slice : maxAttributes : 0">
            {{ attr.names | localName : attr.id }}
          </th>
          <th nzShowExpand *ngIf="dictionary.attributes.length > maxAttributes"></th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <ng-template ngFor let-data [ngForOf]="nzTable.data | nzTree">
          <ng-template ngFor let-node [ngForOf]="data.branch">
            <tr *ngIf="!node.parent || node.parent.expand">
              <td
                [nzIndentSize]="node.level * 20"
                [nzShowExpand]="!!node.children"
                [(nzExpand)]="node.expand"
                (nzExpandChange)="node.toggleExpand($event)">
                <a
                  [routerLink]="[
                    '/dictionaries',
                    dictionary.id,
                    'versions',
                    version.version,
                    'concepts',
                    'edit',
                    node.item.code
                  ]">
                  {{ node.item.code }}
                </a>
              </td>
              <td>{{ node.item.names | localName }}</td>
              <td *ngFor="let attr of dictionary.attributes | slice : maxAttributes : 0">
                {{ formatAttributeValue(attr.id, node.item) }}
              </td>
              <td nzShowExpand [(nzExpand)]="node.attrExpand" *ngIf="dictionary.attributes.length > maxAttributes"></td>
              <td>
                <a (click)="deleteConcept(node.item.code)">{{ 'Delete' | translate }}</a>
              </td>
            </tr>
            <tr [nzExpand]="node.attrExpand" *ngIf="dictionary.attributes.length > maxAttributes">
              <td></td>
              <td colspan="99">
                <p *ngFor="let attr of dictionary.attributes">
                  <strong>{{ attr.names | localName : attr.id }}: </strong>
                  {{ formatAttributeValue(attr.id, node.item) }}
                </p>
              </td>
              <td></td>
            </tr>
          </ng-template>
        </ng-template>
      </tbody>
    </nz-table>
  </hw-table>

  <button (click)="goBack()" nz-button nzType="default">{{ 'core.btn.back' | translate }}</button>
</nz-content>
